module.exports = __webpack_public_path__ + "media/images/official/plancheck_chart_sp-36030e1a6ce89ef5e424a8c1070047a4.jpg";